<template>
  <div class="organization container-fluid">
    <div class="row header-row">
      <div class="col-12 col-md-4 col-lg-6">
        <h1>Device Usage</h1>
      </div>
    </div>
    <section class="main-content">
      <div class="filter">
        <h5>
          Filter
        </h5>
        <form-component>
          <form
            id="usage-filter"
            class="usage-filter row"
            novalidate="novalidate"
            @submit.prevent
          >
            <div
              v-if="$store.getters.isKgbAdminUser"
              class="col-sm-6 col-md-4 col-lg-3 filter-item"
            >
              <input-multi-select
                id="organization"
                v-model="selectedOrg"
                name="organization"
                data-vv-name="organization"
                data-vv-as="Organization"
                label="Organization"
                key-field="key"
                display-field="label"
                :on-change="onOrgFilterChange"
                :options="organizationSelectOptions"
              />
            </div>
            <div class="col-sm-6 col-md-4 col-lg-3 filter-item">
              <input-multi-select
                id="site"
                v-model="selectedSites"
                name="site"
                data-vv-name="site"
                data-vv-as="Site"
                label="Site"
                key-field="key"
                display-field="label"
                :disabled="siteSelectOptions.length <= 2"
                :options="siteSelectOptions"
              />
            </div>
            <div class="col-sm-6 col-md-4 col-lg-3 filter-item">
              <input-multi-select
                id="serial"
                v-model="selectedSerialNumber"
                name="serial"
                data-vv-name="serial"
                data-vv-as="Serial Number"
                label="Serial Number"
                key-field="key"
                display-field="label"
                :options="devicesSelectOptions"
              />
            </div>
            <div class="col-sm-6 col-md-4 col-lg-3 filter-item">
              <input-text
                id="start_date"
                v-model="selectedStartDate"
                name="start_date"
                data-vv-name="start_date"
                data-vv-as="Start Date"
                label="Start Date"
                type="date"
              />
            </div>
            <div class="col-sm-6 col-md-4 col-lg-3 filter-item">
              <input-text
                id="end_date"
                v-model="selectedEndDate"
                name="end_date"
                data-vv-name="end_date"
                data-vv-as="End Date"
                label="End Date"
                :max="maxEndDate"
                type="date"
              />
            </div>
            <div class="col-sm-6 col-md-4 col-lg-3  filter-item">
              <input-select
                id="recorderType"
                v-model="selectedRecorderType"
                name="recorderType"
                data-vv-name="recorderType"
                data-vv-as="Recorder Type"
                label="Recorder Type"
                key-field="key"
                display-field="label"
                :options="recorderTypes"
              />
            </div>
            <div class="col-sm-6 col-md-4 col-lg-3 filter-item">
              <input-select
                id="usageType"
                v-model="selectedUsageType"
                name="usageType"
                data-vv-name="usageType"
                data-vv-as="Usage Type"
                label="Usage Type"
                key-field="key"
                display-field="label"
                :options="usageTypes"
              />
            </div>
            <div class="col-sm-6 col-md-4 col-lg-3 filter-item">
              <input-text
                id="tail_number"
                v-model="selectedTailNumber"
                name="tail_number"
                data-vv-name="tail_number"
                data-vv-as="Tail #"
                label="Tail #"
                type="text"
              />
            </div>
            <div class="col-sm-6 col-md-4 col-lg-3 filter-item">
              <input-text
                id="selectedRecorderPartNumber"
                v-model="selectedRecorderPartNumber"
                name="selectedRecorderPartNumber"
                data-vv-name="selectedRecorderPartNumber"
                data-vv-as="Recorder Part #"
                label="Recorder Part #"
                type="text"
              />
            </div>
            <div class="col-sm-6 col-md-4 col-lg-3 filter-item">
              <input-text
                id="selectedRecorderSerialNumber"
                v-model="selectedRecorderSerialNumber"
                name="selectedRecorderSerialNumber"
                data-vv-name="selectedRecorderSerialNumber"
                data-vv-as="Recorder Serial #"
                label="Recorder Serial #"
                type="text"
              />
            </div>
            <div class="col-sm-6 col-md-4 col-lg-3 filter-item">
              <input-multi-select
                id="selectedReason"
                v-model="selectedReason"
                name="selectedReason"
                data-vv-name="selectedReason"
                data-vv-as="Reason For Download"
                label="Reason For Download"
                key-field="key"
                display-field="label"
                :options="downloadReasonOptions"
              />
            </div>
            <div class="col-sm-6 col-md-4 col-lg-3 filter-item">
              <input-select
                v-if="$store.getters.isKgbAdminUser"
                id="downloadTag"
                v-model="downloadTag"
                name="downloadTag"
                data-vv-name="downloadTag"
                data-vv-as="Download Tag"
                label="Download Tag"
                key-field="key"
                display-field="label"
                :options="downloadTagOptions"
              />
            </div>
            <div class="col-sm-6 col-md-4 col-lg-3 d-flex align-items-center button-area">
              <b-button-group style="width: 100%;">
                <b-button
                  variant="primary"
                  class="btn btn--primary"
                  type="submit"
                  @click="updateFilter()"
                >
                  Filter
                </b-button>
                <b-button
                  variant="light"
                  class="btn"
                  type="button"
                  @click="resetFilter()"
                >
                  Clear Filter
                </b-button>
                <b-dropdown
                  variant="primary"
                  :disabled="exportInProgress"
                >
                  <template #button-content>
                    <span
                      :class="{'invisible': exportInProgress}"
                    >
                      Export
                    </span>
                    <span
                      v-if="exportInProgress"
                      class="inline-loader"
                    >
                      <Loader />
                    </span>
                  </template>
                  <b-dropdown-item @click="exportReport('csv')">
                    CSV
                  </b-dropdown-item>
                  <b-dropdown-item @click="exportReport('xlsx')">
                    Excel
                  </b-dropdown-item>
                  <b-dropdown-item @click="exportReport('pdf')">
                    PDF
                  </b-dropdown-item>
                </b-dropdown>
              </b-button-group>
            </div>
          </form>
        </form-component>
      </div>

      <div
        v-if="!notYetFiltered"
        class="data"
      >
        <div
          v-if="!usage"
          class="col-12"
        >
          <Loader />
        </div>
        <div
          v-else-if="usage.length === 0"
          class="col-12"
        >
          <div class="no-results text-center">
            <div class="vertical-center">
              No Results Found
            </div>
          </div>
        </div>
        <div
          v-else
        >
          <div class="table-data">
            <responsive-table>
              <usage-table
                :report-data="usage"
                :download-file="downloadFile"
                :show-edit-modal="showEditModal"
                :get-usage-change-log="usageChangeLog"
                @update-sort="handleUpdateSort"
              />
            </responsive-table>
          </div>
        </div>
      </div>
    </section>
    <edit-usage-data-modal
      ref="usageModal"
      :do-cancel="closeModal"
      :do-save="doSaveUsage"
    />
  </div>
</template>

<script>
import UserClient from '@/api/UserClient';
import FormComponent from '@/components/FormComponent.vue';
import InputMultiSelect from '@/components/inputs/InputMultiSelect.vue';
import InputSelect from '@/components/inputs/InputSelect.vue';
import InputText from '@/components/inputs/InputText.vue';
import Loader from '@/components/Loader.vue';
import EditUsageDataModal from '@/components/modals/EditUsageDataModal.vue';
import ResponsiveTable from '@/components/ResponsiveTable.vue';
import UsageTable from '@/components/tables/UsageTable.vue';

const calculateDifference = (startValue, endValue) => {
  const startDate = new Date(startValue);
  const endDate = new Date(endValue);
  return Math.round((endDate.getTime() - startDate.getTime()) / 1000);
};

const dateToFormattedString = (dateValue) => {
  const offset = dateValue.getTimezoneOffset();
  const offsetDate = new Date(dateValue.getTime() + (offset * 60 * 1000));
  return offsetDate.toISOString().split('T')[0];
};

export default {
  name: 'Usage',
  components: {
    Loader,
    FormComponent,
    InputText,
    InputSelect,
    InputMultiSelect,
    UsageTable,
    ResponsiveTable,
    EditUsageDataModal,
  },

  data() {
    const dt = new Date();
    return {
      userClient: new UserClient(this.$http),
      organizations: [],
      devices: [],
      sites: [],
      usage: [],
      notYetFiltered: true,
      selectedSortObject: {},
      exportInProgress: false,

      selectedOrg: '',
      selectedSites: 'all',
      selectedSerialNumber: '',
      selectedStartDate: '',
      selectedEndDate: '',
      selectedRecorderType: '',
      selectedUsageType: '',
      selectedTailNumber: '',
      selectedRecorderSerialNumber: '',
      selectedRecorderPartNumber: '',
      selectedReason: '',
      maxEndDate: `${dt.getUTCFullYear()}-${(`0${dt.getUTCMonth() + 1}`).slice(-2)}-${(`0${dt.getUTCDate()}`).slice(-2)}`,
      recorderTypes: [{ key: 'all', label: 'Any Recorder Type' }],
      usageTypes: [
        { key: 'all', label: 'Any Usage Types' },
        { key: 'download', label: 'Download' },
        { key: 'monitor', label: 'Monitor' },
      ],
      downloadReasonOptions: [
      ],
      downloadTagOptions: [
        { key: 'all', label: 'Any Tags' },
        { key: 'PD', label: 'PD' },
        { key: 'OK', label: 'OK' },
      ],
      downloadTag: '',
    };
  },
  computed: {
    organizationSelectOptions() {
      const options = [];
      if (!this.organizations) {
        return options;
      }
      return this.organizations.filter(x => !x.is_removed).map(x => ({
        key: `${x.id}`,
        label: x.name,
      }));
    },
    siteSelectOptions() {
      const defaultOptions = [{ key: '-1', label: 'Primary' }];
      if (!this.sites || this.sites.length === 0) {
        return [];
      }
      return [...defaultOptions, ...this.sites.map(x => ({
        key: `${x.id}`,
        label: x.name,
      }))];
    },
    devicesSelectOptions() {
      if (!this.devices) {
        return [];
      }
      return this.devices
        .filter((device) => {
          if (this.selectedSites === '' || this.selectedSites === 'all') {
            return true;
          }
          const selectedSites = this.selectedSites.split(',').map(x => Number(x));
          return ((device.site && selectedSites.includes(device.site.id))
          || (device.site === null && selectedSites.includes(-1)));
        }).map(x => ({
          key: `${x.id}`,
          label: x.serial_number,
        }));
    },
  },
  watch: {
    // eslint-disable-next-line func-names
    '$route.params': function () {
      const previousString = JSON.stringify(this.buildFilteredRequest());
      this.handleRouteValues({ ...this.$route.query });
      if (previousString !== JSON.stringify(this.buildFilteredRequest())) {
        this.getUsageData();
      }
    },
  },
  mounted() {
    if (this.$store.getters.isKgbAdminUser) {
      this.userClient.getOrganizations().then((orgs) => {
        orgs.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
        this.organizations = orgs;
      }).catch(() => {
        this.organizations = [];
      });
    }

    this.getDevices();
    this.userClient.getDeviceTypes().then((deviceTypes) => {
      const sortedOptions = Object.keys(deviceTypes)
        .map(k => ({ key: k, label: deviceTypes[k] }))
        .sort((a, b) => ((a.label < b.label) ? -1 : 1));
      this.recorderTypes = [...this.recorderTypes, ...sortedOptions];
    }).catch(() => {
      this.recorderTypes = [...this.recorderTypes];
    });

    this.defaultValues();
    this.handleRouteValues(this.$route.query);
    this.updateFilter(false);
    this.getSites();
  },
  methods: {
    getDevices() {
      this.devices = [];
      let organizationFilter = '';
      if (!this.$store.getters.isKgbAdminUser) {
        organizationFilter = this.$store.getters.currentUser.organization_id || -1;
      } else if (this.selectedOrg !== 'all') {
        organizationFilter = this.selectedOrg;
      }

      this.userClient.getDevices(organizationFilter).then((devices) => {
        this.devices = devices;
      }).catch(() => {
        this.devices = [];
      });
    },
    /** Builds a filter request used by filtering data AND exporting */
    buildFilteredRequest() {
      return {
        organization: (this.selectedOrg !== 'all') ? this.selectedOrg : undefined,
        sites: (this.selectedSites !== 'all') ? this.selectedSites : undefined,
        devices: (this.selectedSerialNumber !== 'all') ? this.selectedSerialNumber : undefined,
        startDate: (this.selectedStartDate && new Date(this.selectedStartDate))
          ? dateToFormattedString(new Date(this.selectedStartDate)) : undefined,
        endDate: (this.selectedEndDate && new Date(this.selectedEndDate))
          ? dateToFormattedString(new Date(this.selectedEndDate)) : undefined,
        recorderType: (this.selectedRecorderType !== 'all') ? this.selectedRecorderType : undefined,
        usageType: (this.selectedUsageType !== 'all') ? this.selectedUsageType : undefined,
        tailNumber: this.selectedTailNumber.length > 0 ? this.selectedTailNumber : undefined,
        recorderPartNumber: this.selectedRecorderPartNumber.length > 0
          ? this.selectedRecorderPartNumber : undefined,
        recorderSerialNumber: this.selectedRecorderSerialNumber.length > 0
          ? this.selectedRecorderSerialNumber : undefined,
        recorderTags: (this.selectedReason !== 'all') ? this.selectedReason : undefined,
        downloadTag: (this.downloadTag !== 'all') ? this.downloadTag : undefined,
      };
    },
    handleRouteValues(queryParameterObject) {
      const currentDate = new Date();
      const previousMonth = new Date(currentDate);
      previousMonth.setMonth(previousMonth.getMonth() - 1);

      this.selectedOrg = (queryParameterObject.organization) ? queryParameterObject.organization : 'all';
      this.selectedSites = (queryParameterObject.sites) ? queryParameterObject.sites : 'all';
      this.selectedSerialNumber = (queryParameterObject.devices) ? queryParameterObject.devices : 'all';
      this.selectedStartDate = (queryParameterObject.startDate)
        ? queryParameterObject.startDate : dateToFormattedString(previousMonth);
      this.selectedEndDate = (queryParameterObject.endDate)
        ? queryParameterObject.endDate : dateToFormattedString(currentDate);
      this.selectedRecorderType = (queryParameterObject.recorderType) ? queryParameterObject.recorderType : 'all';
      this.selectedUsageType = (queryParameterObject.usageType) ? queryParameterObject.usageType : 'all';
      this.selectedTailNumber = (queryParameterObject.tailNumber) ? queryParameterObject.tailNumber : '';
      this.selectedRecorderPartNumber = (queryParameterObject.recorderPartNumber) ? queryParameterObject.recorderPartNumber : '';
      this.selectedRecorderSerialNumber = (queryParameterObject.recorderSerialNumber) ? queryParameterObject.recorderSerialNumber : '';
      this.selectedReason = (queryParameterObject.recorderTags) ? queryParameterObject.recorderTags : 'all';
      this.downloadTag = (queryParameterObject.downloadTag) ? queryParameterObject.downloadTag : 'all';

      // need to set muti-selection options after populate from query parameters
      this.downloadReasonOptions = [
        { key: 'Analysis', label: 'Analysis' },
        { key: 'FOQA', label: 'FOQA' },
        { key: 'Raw Data', label: 'Raw Data' },
      ];
    },
    getUsageData() {
      this.usage = null;
      this.userClient.getDeviceUsage(this.buildFilteredRequest()).then((usageRes) => {
        this.usage = usageRes.results.map(x => ({
          ...x,
          fileDeletedBy: (x.fileDeletedBy && x.fileDeletedUserIsAdmin && !this.$store.getters.isKgbAdminUser) ? 'Admin' : x.fileDeletedBy,
          fileDeletedDate: x.fileDeletedDate ? new Date(x.fileDeletedDate) : null,
          duration: calculateDifference(x.startTime, x.stopTime),
        }));
      }).catch(() => {
        this.usage = null;
      });
    },
    async getSites() {
      const organizationFilter = (!this.$store.getters.isKgbAdminUser)
        ? `${this.$store.getters.currentUser.organization_id}`
        : this.selectedOrg;

      if (organizationFilter && organizationFilter.length > 0 && organizationFilter !== 'all' && organizationFilter.indexOf(',') === -1) {
        this.sites = await this.userClient.getSitesForOrganization(organizationFilter);
      } else {
        this.sites = [];
      }
    },
    onOrgFilterChange() {
      setTimeout(() => {
        this.devices = [];
        this.selectedSerialNumber = 'all';
        this.selectedSites = 'all';
        this.getDevices();
        this.getSites();
      }, 10);
    },
    updateFilter(updateRouter = true) {
      this.notYetFiltered = false;
      this.selectedSortObject = {};
      if (updateRouter) {
        this.$router.push({ query: this.buildFilteredRequest() });
      }
      this.getUsageData();
    },
    downloadFile(deviceId, filename) {
      this.userClient.downloadFile(deviceId, filename);
    },
    handleUpdateSort(event) {
      this.selectedSortObject = event;
    },
    defaultValues() {
      const currentDate = new Date();
      const previousMonth = new Date(currentDate);
      previousMonth.setMonth(previousMonth.getMonth() - 1);
      this.selectedSortObject = {};
      this.notYetFiltered = true;
      this.selectedOrg = 'all';
      this.selectedSerialNumber = 'all';
      this.selectedStartDate = dateToFormattedString(previousMonth);
      this.selectedEndDate = dateToFormattedString(currentDate);
      this.selectedRecorderType = 'all';
      this.selectedUsageType = 'all';
      this.selectedTailNumber = '';
      this.selectedReason = 'all';
    },
    resetFilter() {
      this.defaultValues();
      this.updateFilter();
    },
    exportReport(filterType) {
      this.exportInProgress = true;
      this.userClient.getExportedData(
        {
          ...this.selectedSortObject,
          ...this.buildFilteredRequest(),
          type: filterType,
        },
      ).then(() => {
        this.exportInProgress = false;
      }).catch(() => {
        this.exportInProgress = false;
      });
    },
    showEditModal(usageData) {
      this.$refs.usageModal.$children[0].show();
      this.$refs.usageModal.setModal(usageData);
    },
    closeModal() {
      this.$refs.usageModal.$children[0].hide();
    },
    usageChangeLog(usageId) {
      return this.userClient
        .getDeviceUsageChangeLog(usageId).then(x => x.results).catch(() => []);
    },
    doSaveUsage(saveObject, callback) {
      this.userClient.updateUsageData(saveObject)
        .then(() => {
          callback();
          this.closeModal();
          this.usage = this.usage.map((usage) => {
            if (usage.id === saveObject.id) {
              return { ...usage, ...saveObject };
            }
            return usage;
          });

          this.$store.commit('setGlobalAlert', {
            msg: 'Usage Data Saved!',
          });
        }).catch(() => {
          callback();
          this.$store.commit('setGlobalAlert', {
            msg: 'Unable to save usage data. Please try again!', error: true,
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.usage-filter {
  flex: 1;
}

.button-area {
  margin-bottom: 10px;
}

.main-content {
  display: flex;
  flex-direction: column;

  .filter {
    width: 100%;
  }

  .data {
    flex: 1;
  }
}
</style>
